import { DataContainer } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import Style from "./card.module.scss";

const CardHeroShimmer = ({ count = 8 }) => {
  return (
    <DataContainer propStyle={{ root: Style.container_root }}>
      <div className="col-12">
        <div className="row">
          {[...Array(count)].map((_, i) => (
            <div className={`${Style.report_root} col`} key={i}>
              <span
                className="shimmer pro-d-block pro-mb-2"
                style={{ height: 12, width: "75%" }}
              ></span>
              <span
                className="shimmer pro-d-block"
                style={{ height: 20, width: "45%" }}
              ></span>
            </div>
          ))}
        </div>
      </div>
    </DataContainer>
  );
};

export default CardHeroShimmer;
